import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { RegionMiniEntity } from '../../domain/entities/RegionMiniEntity'
import type { RegionAdminListedDto } from '@/backend/auth'
export class RegionMiniModel extends RegionMiniEntity {
  constructor(dataDto: RegionAdminListedDto) {
    super()
    mapEntityProperties<RegionMiniEntity>(this, dataDto)
  }
}
